module.exports = __webpack_public_path__ + "static/media/Stephany.47f4cf49.png";